import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useCreateAndAuthorizeBlockedSlot = (handleClose: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const {
    mutate: createAndAuthorizeBlockedSlot,
    isLoading: createAndAuthorizeBlockedSlotIsLoading,
  } = trpc.createAndAuthorizeBlockedSlot.useMutation({
    onSuccess: () => {
      trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

      showSuccess(
        t('common.notification.success.message', {
          action: 'created and authorized',
          entity: 'blocked slot',
        })
      );

      return handleClose && handleClose();
    },
    onError: () => {
      showError(
        t('common.notification.error.message', {
          action: 'create',
          entity: 'blocked slot',
        })
      );
      handleClose();
    },
  });

  return {
    createAndAuthorizeBlockedSlot,
    createAndAuthorizeBlockedSlotIsLoading,
  };
};
